import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.cache

const aiImageCache = createSelector(selector, state => state.aiImageCache)
const aiVideoCache = createSelector(selector, state => state.aiVideoCache)

export const cacheSelectors = {
  aiImageCache,
  aiVideoCache
}
